import { Stack, Typography } from "@mui/material";
import WaydFrequencyChart from "../WaydFrequencyChart";
import { WaydSectionSimpleProps } from "./types";

export default function WaydSectionSimple({
  offenseFrequencyData,
  defenseFrequencyData,
  vertical = false,
}: WaydSectionSimpleProps) {
  return (
    <Stack>
      <Stack sx={{ flex: 1 }}>
        <Typography variant="h5" textAlign="center" whiteSpace="nowrap">
          Role Breakdown
        </Typography>

        <Stack
          direction={vertical ? "column" : "row"}
          justifyContent={vertical ? undefined : "space-evenly"}
        >
          <Stack>
            <Typography variant="body1" textAlign="center" fontWeight={600}>
              OFFENSE
            </Typography>
            <WaydFrequencyChart data={offenseFrequencyData} />
          </Stack>

          <Stack>
            <Typography variant="body1" textAlign="center" fontWeight={600}>
              DEFENSE
            </Typography>
            <WaydFrequencyChart data={defenseFrequencyData} />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
